import { render, staticRenderFns } from "./DestinationLocationDetails.vue?vue&type=template&id=644c9c20&scoped=true&"
import script from "./DestinationLocationDetails.vue?vue&type=script&lang=js&"
export * from "./DestinationLocationDetails.vue?vue&type=script&lang=js&"
import style0 from "./DestinationLocationDetails.vue?vue&type=style&index=0&id=644c9c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c9c20",
  null
  
)

export default component.exports